import { render, staticRenderFns } from "./AssignmentDetails.vue?vue&type=template&id=f7e105b4&scoped=true&"
import script from "./AssignmentDetails.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetails.vue?vue&type=style&index=0&id=f7e105b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e105b4",
  null
  
)

export default component.exports